import { render } from "./BackgroundVideo.vue?vue&type=template&id=187177c3&scoped=true"
import script from "./BackgroundVideo.vue?vue&type=script&lang=js"
export * from "./BackgroundVideo.vue?vue&type=script&lang=js"

import "./BackgroundVideo.vue?vue&type=style&index=0&id=187177c3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-187177c3"]])

export default __exports__